import { Card, Popover } from "antd";
import React, { useEffect, useState } from "react";
import "./genericcardcomponent.css";
import { MoreOutlined } from "@ant-design/icons";
import EachActionComponent from "./actions/EachActionComponent";
import { metaDataKeys, statusPromptText } from "../../../careprovider/visits/utils";
import CustomModal from "../../../../components/generic/custommodal/CustomModal";
import SecondaryButton from "../../../../components/generic/buttons/SecondaryButton";
import { cardIcons } from "./utils/cardIcons";

const GenericCardComponent = ({ data, cssClassName }) => {

  const [openSecondaryActionsModal, setOpenSecondaryActionsModal] = useState(false);
  const [userAttributeData, setUserAttributeData] = useState(null);
  const [userPreferenceData, setUserPreferenceData] = useState(null);

  const handleUserAttributeDataChange = (attributeData) => {
    setUserAttributeData(attributeData);
  };
  const handleUserPreferenceDataChange = (preferenceData) => {
    setUserPreferenceData(preferenceData);
  };

  useEffect(() => {
    handleUserAttributeDataChange(userAttributeData);
    handleUserPreferenceDataChange(userPreferenceData);
  }, [userAttributeData, userPreferenceData])

  const SecondaryActionsModalFooter = (
    <SecondaryButton buttonText="Close" handleOnClick={() => setOpenSecondaryActionsModal(false)} />
  )

  const secondaryActionsMenu = (
    <div className="actioncard-popover-content-secondary-actions">
      {data?.secondaryActions?.map((action,index) => (<EachActionComponent action={action} key={index} actionData={data?.actionData} actionType="secondary" />))}
    </div>
  )


  return (
    <Card className="main-card-section card-border">
      <div className="card-data-section">
        <div className="card-avatar-info-section">
          {data?.avatar ? <div className="card-avatar-section">{data?.avatar} </div> : null}
          <div className="card-info-section">
            <div className="card-primary-info-section">
              <div>
                {data?.primaryHeading && <div className="card-primary-header-section">{data?.primaryHeading}</div>}
                {data?.additionalPrimaryData && <div className="additional-primary-header-section-data">{data?.additionalPrimaryData}</div>}
              </div>
              <div className={data?.actionIcons ? "card-primary-info-status-icons-section card-primary-info-status-icons" : "card-primary-info-status-icons-section"}>
                {data?.statusInfo && <div className={`card-status-info card-status-info-${statusPromptText[data?.statusInfo]}`}>{statusPromptText[data?.statusInfo] || data?.statusInfo}</div>}
                {data?.additionalInfo && <div className="card-additional-info">{data?.additionalInfo}</div>}
                {data?.actionIcons && <div className="card-icon-actions">
                  {data?.actionIcons?.map((action, index) => (<EachActionComponent action={action} key={index} actionData={data?.actionData} showIconsOnly={true} />))}
                </div>}
              </div>
            </div>
            {data?.secondaryHeading && <div className={`card-secondary-header-section card-secondary-header-section-${cssClassName}`}>{data?.secondaryHeading}</div>}
            {data?.description && <div className="card-description-section">{data?.description}</div>}
            {data?.additionalData ? (
              <div className="card-additional-data-section">
                {Object.keys(data?.additionalData).map((item, index) => (
                  <div className="card-additional-data" key={index}>
                    {data?.showIconsForAdditionalData && cardIcons[item]}
                    <span>{data?.additionalData[item]}</span>
                    {data?.showIconsForAdditionalData ? <span>&nbsp; &nbsp; &nbsp;</span> : (index !== Object.keys(data?.additionalData).length - 1 && <span>,&nbsp;</span>)}
                  </div>
                ))}
              </div>
            ) : null}
            {data?.metaData && (
              <div className="card-meta-data-section">
                {Object.keys(data?.metaData).map((item, index) => (
                  <Popover key={index} content={<div className="actioncard-popover-content">{data?.metaData?.[item]}</div>} placement="top" overlayClassName="actioncard-popover">
                    <div className="card-meta-data">{metaDataKeys[item]}</div>
                  </Popover>
                ))}
              </div>
            )}
          </div>
        </div>
        {!data?.cardType && (
          <div className="card-action-section">
            {data?.primaryActions && data?.primaryActions?.length > 0 ? (
              <div className="primary-action-section">
                {data?.primaryActions?.map((action, index) => (<EachActionComponent action={action} key={index} actionData={data?.actionData} actionType="primary" />))}
              </div>
            ) : null}
            {data?.secondaryActions?.length > 0 && (
              <div className="secondary-action-section">
                <Popover placement="bottom" showArrow={false} content={secondaryActionsMenu} overlayClassName="actioncard-popover" trigger={['click']}>
                  <MoreOutlined />
                </Popover>
              </div>
            )}
          </div>
        )}
        {data?.cardType === "visitDetailsCard" && (
          <div className="visit-details-action-content">
            {data?.primaryActions && data?.primaryActions?.length > 0 ? (
              <div className="primary-action-content">
                {data?.primaryActions?.map((action, index) => (<EachActionComponent action={action} key={index} actionData={data?.actionData} actionType="primary" cardType="visitDetailsCard" />))}
              </div>
            ) : null}
            {<div className="secondary-action-content">
              {data?.secondaryActions?.map((action, index) => (<EachActionComponent action={action} key={index} actionData={data?.actionData} actionType="secondary" cardType="visitDetailsCard" />))}
            </div>}
          </div>
        )}
      </div>

      {openSecondaryActionsModal && (
        <CustomModal isModalOpen={openSecondaryActionsModal} closeModal={setOpenSecondaryActionsModal} footer={[SecondaryActionsModalFooter]} closable={false} cssClassName="secondary-actions-modal">
          <div className="secondary-action-mmodal-content">
            {data?.secondaryActions?.map((action, index) => (<EachActionComponent action={action} key={index} actionData={data?.actionData} actionType="secondary" />))}
          </div>
        </CustomModal>
      )}
    </Card>
  );
};

export default GenericCardComponent;
